module.exports = __webpack_public_path__ + "img/manda_023.04d2178e.png";